import { useTranslation } from "../../../../localization/useTranslation";
import ExternalAuditTable from "../../../../common/components/questionnaireComponents/externalAuditTable/ExternalAuditTable";
import useProcessingActivityAudits from "./ProcessingActivityAudits.hooks";

export interface IProcessingActivityAuditsProps {
    processingActivityId: string;
    processingActivityName: string;
    onAuditsChanged: () => void;
}

function ProcessingActivityAudits(props: IProcessingActivityAuditsProps) {
    const { translateString } = useTranslation();
    const { externalAudits, isLoadingExternalAudits, refetchExternalAudits } = useProcessingActivityAudits({
        processingActivityId: props.processingActivityId,
    });

    return (
        <ExternalAuditTable
            data={externalAudits}
            isLoading={isLoadingExternalAudits}
            refetch={() => {
                refetchExternalAudits();
                props.onAuditsChanged();
            }}
            pageType="processingActivity"
            emptyStateText={translateString("noExternalAudits")}
            processingActivityId={props.processingActivityId}
            processingActivityName={props.processingActivityName}
            sessionStorageKey={`processing-activity-${props.processingActivityId}-external-audits-filters`}
        />
    );
}

export default ProcessingActivityAudits;
